import { noticeError as newrelicNoticeError } from 'clients/newrelic'
import { captureException as sentryCaptureException } from 'clients/sentry'

export function logAndNotify(error, extra) {
  newrelicNoticeError(error, extra)
  sentryCaptureException(error, { extra: extra })
}
